import React, { useEffect, useState } from 'react'
import s from './AffiliateProfile.module.css'
import Image from 'next/image'

interface AffiliateProfileProps {
  affiliate: {
    nome: string
    titulo: string
    imagem_perfil_url?: string
    imagem_banner_url?: string
    instagram?: string
    tiktok?: string
    youtube?: string
    bio?: string
    como_conheceu?: string
    como_conheceu_outros?: string
    atividade_principal?: string
    atividade_principal_outros?: string
    status?: string
  }
  withHeader?: boolean
  onlyInfo?: boolean
}

const DESCRIPTION_LENGTH = 280

const AffiliateProfile: React.FC<AffiliateProfileProps> = ({ affiliate, withHeader = true, onlyInfo = false }) => {
  const [crop, setCrop] = useState(false)
  const { nome, titulo, imagem_perfil_url, imagem_banner_url, bio, instagram, tiktok, youtube } = affiliate

  useEffect(() => {
    setCrop(!!(bio && bio.length > DESCRIPTION_LENGTH))
  }, [bio])

  return (
    <div className={s.root}>
      <div className={s.content}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
          <div className={s.avatar}>
            <Image
              src={imagem_perfil_url || '/assets/images/afiliados/icon-perfil-afiliado.png'}
              alt={nome}
              width={160}
              height={160}
            />
          </div>
          <div className={s.info}>
            <div className={s.title}>{nome}</div>
            <div className={s.description}>
              {crop ? `${bio?.substr(0, DESCRIPTION_LENGTH)}...` : bio}
              <div className={s.crop}>
                {bio && bio.length > DESCRIPTION_LENGTH && (
                  <button type="button" className={s.showMoreBtn} onClick={() => setCrop(!crop)}>
                    Mostrar {crop ? 'mais' : 'menos'}
                  </button>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default AffiliateProfile 